import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { PlanClaim, PlanDetails, assistanceType } from '@self-fix/data-access';
import { filter } from 'rxjs';
import { LoadingStatus } from './loading-status.enum';

interface PlanClaimsState {
  planClaims: PlanDetails | null;
  activePlanNumber: string | null;
  plans: PlanClaim[];
  assistance: assistanceType | null;
  error: string | null;
  status: LoadingStatus;
}

@Injectable({
  providedIn: 'root',
})
export class PlanClaimsStore extends ComponentStore<PlanClaimsState> {
  readonly planClaims$ = this.select((state) => state.planClaims);
  readonly activePlanNumber$ = this.select((state) => state.activePlanNumber);
  readonly assistance$ = this.select((state) => state.assistance);
  readonly status$ = this.select((state) => state.status);
  readonly activePlan$ = this.select((state) =>
    state.plans.find((plan) => {
      return plan.plan_number === state.activePlanNumber;
    })
  );
  readonly plans$ = this.select((state) => {
    const plansWithClaims = state.plans.map((plan) => ({
      ...plan,
      isActive: plan.plan_number === state.activePlanNumber,
    }));
    return plansWithClaims;
  }).pipe(filter((claims: any) => claims && claims.length));

  constructor() {
    super({
      planClaims: null,
      activePlanNumber: null,
      plans: [],
      assistance: 'None',
      error: null,
      status: LoadingStatus.NotLoaded,
    });
  }

  setPlanClaims = this.updater((state, planClaims: PlanDetails | null) => ({
    ...state,
    planClaims,
    error: null,
  }));

  setPlans = this.updater((state, plans: PlanClaim[]) => ({
    ...state,
    plans,
    error: null,
  }));

  setActivePlan = this.updater((state, activePlanNumber: string | null) => {
    if (activePlanNumber?.length !== 10) {
      return {
        ...state,
        error: 'Invalid plan',
      };
    }
    return {
      ...state,
      activePlanNumber,
      loading: false,
      error: null,
    };
  });

  setAssistance = this.updater((state, assistance: assistanceType | null) => {
    return {
      ...state,
      assistance,
      error: null,
    };
  });

  setStatus = this.updater((state, status: LoadingStatus) => {
    return {
      ...state,
      status,
    };
  });
}
